import { Text, TextProps } from "@mantine/core"
interface Props extends Omit<TextProps, "fw"> {
  productionTitle: {
    text: string | null
    isPerformance: boolean
  }
}
export function ProductionTitleText({ productionTitle, ...props }: Props) {
  return (
    <Text {...props} fw={productionTitle.isPerformance ? "bold" : undefined}>
      {productionTitle.isPerformance
        ? productionTitle.text?.toUpperCase()
        : productionTitle.text}
    </Text>
  )
}
